// extracted by mini-css-extract-plugin
export default {"text_link":"TermsAndConditions_text_link__NIW2g"};